export default "__VITE_ASSET__B9weMwa9__"